import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=1e3d56c8&"
import script from "./Publications.vue?vue&type=script&lang=ts&"
export * from "./Publications.vue?vue&type=script&lang=ts&"
import style0 from "./Publications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports